import React, { Component } from 'react';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import { getFooter } from '../../action/anueInfoAction';
import { withRouter } from 'react-router';

class Footer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isOpen: true
        }
    }

    componentWillMount() {
        this.props.getFooter();
    }

    render() {
        let openLink = "/FundSpec/OpenAcct/";
        return <footer style={{ paddingTop: '30px' }}>
            <div className="anueContainer">
                <div className="footer__warning">
                    <div dangerouslySetInnerHTML={{__html: this.props.FooterInfo}}></div>
                    <div>
                        <ul>
                            <li>
                            <p>本網站最佳瀏覽體驗建議使用Google Chrome、Edge、Safari，相關詳情請參閱「<a rel="noopener noreferrer" target="_blank" href="https://www.anuefund.com/customer/problem/%E5%B9%B3%E5%8F%B0%E6%93%8D%E4%BD%9C%E6%8C%87%E5%8D%97?item=1">瀏覽器建議設定</a>」。</p>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="footerBottom">
                    <p>鉅亨證券投資顧問股份有限公司｜台北市信義區松仁路 89 號 18 樓 B 室｜113金管投顧新字第 003 號</p>
                    <p>客服信箱： <a href="mailto:cs@anuefund.com.tw">cs@anuefund.com.tw</a>｜服務專線：(02)2720-8126｜服務時間：09:00-17:00｜鉅亨投顧獨立經營管理</p>
                </div>
            </div>
            <ul className="fixedButtoms">
                <li>
                    <a style={{borderRadius:"2px"}} className="btn" rel="noopener noreferrer" target="_blank" href="https://www.facebook.com/share.php?u=https://www.anuefund.com/FundSpec/GoodDay/"> </a>
                </li>
                <li>
                    <a style={{borderRadius:"2px"}} className="btn" rel="noopener noreferrer" target="_blank" href="http://line.me/R/msg/text/?好日子 https://www.anuefund.com/FundSpec/GoodDay/"> </a>
                </li>
                <li>
                    <a style={{borderRadius:"2px"}} className="btn" rel="noopener noreferrer" target="_blank" href="mailto:?Subject=「好日子」退休專案， 活動期間內申購即享單筆０手續費與定期定額指定基金3年0手續費&body=好日子」退休專案 ，8強外資基金品牌聯手，精選多檔基金，打造多元退休投資組合，活動期間內申購即享單筆０手續費與定期定額指定基金3年0手續費。https://www.anuefund.com/FundSpec/GoodDay/"> </a>
                </li>
                <li>
                    <div style={{borderRadius:"2px"}} className="btn" href="#"><span style={{ width: "135px" }}> {/* 原始 width:130 待基金節活動過後改回 */}
                        <div className="icon-ico_smile"></div><a style={{ color: "white" }} href={openLink} rel="noopener noreferrer" target="_blank">立即開戶</a></span></div>
                </li>
            </ul>
        </footer>;
    }
}
function mapStateToProps(state) {
    return {
        FooterInfo: state.anueInfoState.FooterInfo
    };
}
export default connect(mapStateToProps, { getFooter })(withRouter(Footer));